import { 
    cancelStripePayment, 
    postStripeCustomer, 
    postStripePayment,
    getStripePayment,
    resetStripeReader
} from "./bedrockAPI";

const delay = ms => new Promise(res => setTimeout(res,ms));

export async function handleStripePayment({
    customerData,
    amount,
    description,
    onStatusChange,
    onError,
    onSuccess,
    onCancellable,
    onPaymentStarted,
    terminalID = process.env.REACT_APP_STRIPE_PAYMENT_READER_ID
}) {
    let customerId = null;
    try {
        // Create customer
        onStatusChange("Creating Customer...");
        console.log(customerData);
        const stripeCustomerResponse = await postStripeCustomer(customerData);
        customerId = stripeCustomerResponse.id;
        
        onCancellable(true);
        onStatusChange("Requesting Payment from Card Reader...");
        
        // Create payment request
        const stripePaymentRequest = {
            amount: amount,
            readerID: terminalID,
            customerID: customerId,
            description: description,
            customerEmail: stripeCustomerResponse.email,
        };
        
        let paymentError = false;
        let errorMessage = "Is the Card Reader On?";
        let alreadyCancelled = true;
        let stripePaymentResponse = null;
        
        try {
            stripePaymentResponse = await postStripePayment(stripePaymentRequest);
            alreadyCancelled = false;
            
            // Notify that payment has started and pass payment intent
            if(onPaymentStarted && stripePaymentResponse) {
                onPaymentStarted(stripePaymentResponse);
            }
            
            // Poll for payment status
            while(true) {
                if(stripePaymentResponse) {
                    await delay(2000);
                    stripePaymentResponse = await getStripePayment(stripePaymentResponse);
                    
                    if(stripePaymentResponse.status === "canceled") {
                        errorMessage = "Stripe Payment Cancelled";
                        alreadyCancelled = true;
                        throw new Error(errorMessage);
                    } else if(stripePaymentResponse.status === "succeeded") {
                        onStatusChange("Payment Complete");
                        onCancellable(false);
                        onSuccess(customerId);
                        break;
                    }
                } else {
                    errorMessage = "Stripe Payment Could Not Be Found";
                    throw new Error(errorMessage);
                }
            }
        } catch(error) {
            console.log(error);
            onStatusChange("Payment Failed");
            onError("Unable to process payment - canceling... " + errorMessage);
            paymentError = true;
        }

        // TODO: Create the subscriptions if applicable
        // if(customerData?.metadata?.qtyJobSight > 0 || customerData?.metadata?.qtyJobSightPro > 0) {
        //     await createJobSightSubscription(stripeCustomerResponse.id, customerData.metadata.qtyJobSight, customerData.metadata.qtyJobSightPro);
        // }
        
        // Handle payment errors
        if(paymentError) {
            try {
                if(!alreadyCancelled) {
                    const cancellationRequest = {
                        paymentIntentID: stripePaymentResponse.id,
                        terminalID: terminalID
                    };
                    await cancelStripePayment(cancellationRequest);
                    onError("Payment Has Been Cancelled");
                }
                await delay(5000);
                await resetStripeReader(terminalID);
            } catch(error) {
                console.log(error);
                onStatusChange("Error");
                onError("Payment could not be cancelled - please contact a Bedrock Wireless Rep");
            }
        }
    } catch(error) {
        console.log(error);
        onStatusChange("Error");
        onError("Unable to create customer -- Are you connected to the Network?");
    }
}

export async function cancelStripePaymentSession(paymentId, terminalID = process.env.REACT_APP_STRIPE_PAYMENT_READER_ID) {
    if(paymentId) {
        try {
            const cancellationRequest = {
                paymentIntentID: paymentId,
                terminalID: terminalID
            };
            return await cancelStripePayment(cancellationRequest);
        } catch(error) {
            console.log(error);
            throw new Error("Unable to cancel -- Contact a Bedrock Rep");
        }
    }
}
